<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="terminals"
    :title="`${$t('title.selectterminal')}`"
    idProperty="TerminalId"
    nameProperty="TerminalName"
    allSelectId="terminalAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="TerminalNumber"
    :defaultItems="defaultItems"
    viewName="TerminalSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      terminals: [],
      columns: [
        {
          name: "TerminalNumber",
        },
        {
          name: "TerminalName",
        },
      ],
      id: "terminalSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(item) {
      this.$emit("onSaved", item);
    },
    getItems(dTO) {
      const vm = this;
      this.$api.terminals.getPages(dTO).then((data) => {
        vm.terminals = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
